import { __decorate } from "tslib";
// Core
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
// Extends
// Children
import CloseIcon from '@/components/v3/CloseIcon.vue';
// Models / Helpers
// Queries / Mutations
let ProductThumb = class ProductThumb extends Vue {
    get productPhoto() {
        return (this.product.featuredPhotoUrl || this.product.featuredGalleryPhoto?.galleryBlob.originalUrl);
    }
};
__decorate([
    Prop({ type: Object, default: null })
], ProductThumb.prototype, "product", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], ProductThumb.prototype, "closeIcon", void 0);
__decorate([
    Prop({ type: Boolean, default: null })
], ProductThumb.prototype, "small", void 0);
ProductThumb = __decorate([
    Component({
        components: {
            CloseIcon,
        },
    })
], ProductThumb);
export default ProductThumb;
